<div class="badge-trend" *ngIf="trendPercentage !== 0" [ngClass]="{ 'badge-inc': trendPercentage > 0, 'badge-dec': trendPercentage < 0, 'badge-muted': isMuted }">
  <svg *ngIf="trendPercentage > 0 && !isMuted" class="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="width: 12px; height: 12px; stroke-width: 2.5;">
    <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
  </svg>
  <svg *ngIf="trendPercentage < 0 && !isMuted" class="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="width: 12px; height: 12px; stroke-width: 2.5;">
    <path stroke-linecap="round" stroke-linejoin="round" d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6" />
  </svg>
  <span>{{ trendPercentage > 0 ? '+' : '' }}{{ trendPercentage | number : '1.0-2' }}%</span>
</div>
